import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9a75216c")

_pushScopeId("data-v-9a75216c")
const _hoisted_1 = { id: "TalkFutureTalents" }
const _hoisted_2 = { class: "talk-future-talents" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline talk-headline" }, "今度お話しする", -1)
const _hoisted_4 = {
  class: "talk-future-talents-list scrolling-component",
  ref: "scrollComponent"
}
const _hoisted_5 = {
  key: 0,
  class: "talk-future-img",
  src: _imports_0
}
const _hoisted_6 = {
  key: 2,
  class: "next-live-box"
}
const _hoisted_7 = { class: "next-live-text txt txt-wt txt-detail" }
const _hoisted_8 = { class: "talent-name txt txt-small" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.futureTalents, (futureTalent, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "talk-future-talents-box",
            key: index,
            onClick: ($event: any) => (_ctx.openTalent(futureTalent.talentID))
          }, [
            (futureTalent.mainImage === '')
              ? (_openBlock(), _createBlock("img", _hoisted_5))
              : (_openBlock(), _createBlock(_component_Imgix, {
                  key: 1,
                  class: "talk-future-img",
                  imageUrl: futureTalent.mainImage,
                  imageSize: _ctx.imageSize
                }, null, 8, ["imageUrl", "imageSize"])),
            (futureTalent.liveStatus === 3)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "next-live-icon",
                    icon: ['far', 'clock']
                  }),
                  _createVNode("div", _hoisted_7, _toDisplayString(futureTalent.convertUnixToDate), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_8, _toDisplayString(futureTalent.formatDisplayName), 1)
          ], 8, ["onClick"]))
        }), 128))
      ], 512),
      _createVNode(_component_Loading, {
        class: "loading",
        isActive: _ctx.isLoading
      }, null, 8, ["isActive"])
    ])
  ]))
})